export const BuscaParceirosEntity = {
    cidade: '',
    page: 0,
    page_size: 70,
    totalPages: 10,
}